import "./afsprakenList.css"
const AfsprakenList = props => {
    return (
    <ul className={"afspraken-lijst"}>{props.children}</ul>
    )
}

export default AfsprakenList